import {Component, Input, OnInit} from '@angular/core';
import {UnwetterWarnungen} from '../../../../../model/unwetter/unwetter';

@Component({
  selector: 'app-detail-warnung',
  templateUrl: './detail-warnung.component.html',
  styleUrls: ['./detail-warnung.component.css', '../unwetter-detail.component.css']
})
export class DetailWarnungComponent {

  @Input()
  unwetterWarnungen: UnwetterWarnungen;
  @Input()
  header: string;

  constructor() {
  }


}
